import { render } from "./CategoryTypeEditModalPopup.vue?vue&type=template&id=01606ca4&scoped=true"
import script from "./CategoryTypeEditModalPopup.vue?vue&type=script&lang=js"
export * from "./CategoryTypeEditModalPopup.vue?vue&type=script&lang=js"

import "./CategoryTypeEditModalPopup.vue?vue&type=style&index=0&id=01606ca4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01606ca4"]])

export default __exports__